import { render, staticRenderFns } from "./TypeDef.vue?vue&type=template&id=1c0bc68e&scoped=true"
import script from "./TypeDef.vue?vue&type=script&lang=js"
export * from "./TypeDef.vue?vue&type=script&lang=js"
import style0 from "./TypeDef.vue?vue&type=style&index=0&id=1c0bc68e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0bc68e",
  null
  
)

export default component.exports